import { useMemo } from 'react'
import { RadioButton } from 'src/components/radioButton'
import { mascaraCep } from 'src/util/formatar'
import { ZipcodeAddress } from '../../types'
import {
  AddressText,
  Box,
  MainAddressBox,
  MainAddressText,
  RadioContainer,
  ZipcodeDetail,
  ZipcodeRow,
  ZipcodeText,
} from './styles'

type Props = {
  address: ZipcodeAddress
  setZipcodeValue: (value: string) => void
  onSubmit: (zipcode: string) => void
  isSelected: boolean
}

const ZipcodeSelector = ({ address, onSubmit, isSelected }: Props) => {
  const getFullAddress = useMemo(() => {
    const dataAddress = [
      address.logradouro,
      address.numero,
      address.complemento,
      address.bairro,
    ]

    return dataAddress.filter((value) => !!value).join(', ')
  }, [address])

  return (
    <Box>
      <RadioContainer onClick={() => onSubmit(mascaraCep(address.cep))}>
        <RadioButton checked={isSelected} />
      </RadioContainer>
      <ZipcodeDetail>
        <ZipcodeRow>
          <ZipcodeText>{`CEP ${mascaraCep(address.cep)}`}</ZipcodeText>
          {address.padrao && (
            <MainAddressBox>
              <MainAddressText>Principal</MainAddressText>
            </MainAddressBox>
          )}
        </ZipcodeRow>
        <AddressText>{getFullAddress}</AddressText>
      </ZipcodeDetail>
    </Box>
  )
}

export default ZipcodeSelector
